import FileHelper from "@/utils/common/fileHelper";
import nfetch from "@/utils/events/nfetch";

import UsuarioService from "../usuarioService";

type ServicesTypes =
    | "ClientePDF"
    | "FracionamentoPDF"
    | "OrdemFracionamentoPDF"
    | "OrcamentoPDF"
    | "SessaoCaixaPDF"
    | "LivroRegistroEspecificoPDF"
    | "RelatorioPDF"
    | "BalancoCompletoPDF"
    | "VeterinarioPDF"
    | "FichaTecnica"
    | "BspoPDF"
    | "Siproquim"
    | "CurvaABCPDF"
    | "DeclaracaoConteudoPDF"
    | "MapaSiproquimPDF"
    | "MelhorCompraPDF"
    | "ManipuladoresPDF"
    | "SPED"
    | "FormulaPadraoPDF"
    | "RegistroReceituarioPDF"
    | "RecompensaPDF"
    | "RomaneioEntregaPDF"
    | string;

export default class PDFService {
    protected controllerName: ServicesTypes;
    protected usuarioService: UsuarioService;

    constructor(controllerName: ServicesTypes) {
        this.controllerName = controllerName;
        this.usuarioService = new UsuarioService();
    }

    public async geraPDF(id: number) {
        const url = `/${this.controllerName}/GeraPDF?id=${id}`;
        await this.imprimirPDF(url);
    }

    public async geraPDFWithFilters(data: object) {
        const url = `/${this.controllerName}/GeraPDFWithFilters?filters=${JSON.stringify(data)}`;
        await this.imprimirPDF(url);
    }

    public async geraXLSWithFilters(data: object): Promise<void> {
        const url = `/${this.controllerName}/GeraXLSWithFilters?filters=${encodeURIComponent(JSON.stringify(data))}`;
        const response = await nfetch(url, { credentials: "same-origin" });
        const blob = await response.blob();
        const contentDisposition = response.headers.get("Content-Disposition") ?? "";
        const rawFileName = contentDisposition.split("filename=")[1]?.split(";")[0] ?? "relatorio.xlsx";
        const fileName = rawFileName.replace(/"/g, "").trim();
        FileHelper.download(
            blob,
            fileName,
            response.headers.get("Content-Type") ?? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        );
    }

    public async imprimirPDF(path: string) {
        const shortToken = await this.usuarioService.getShortToken().resolveWithText();
        window.open(`${process.env.VUE_APP_ROOT_API}${path}&short_token=${shortToken}`);
    }

    public downloadPDF(path: string): void {
        FileHelper.downloadPDF(`${process.env.VUE_APP_ROOT_API}${path}`);
    }
}
